<nav class="navbar bg-inverse border-bottom px-3">
  <a class="navbar-brand p-1" href="#">
    @if (currentLogoUrl()) {
      <img [src]="currentLogoUrl()" id="header-logo" alt="Megabus" height="28" />
    } @else {
      <img id="header-logo" src="logo-blue.svg" alt="Megabus" height="28" />
    }
  </a>
  @if (authService.isLoggedIn()) {
    <div class="dropdown dropstart d-md-none d-block">
      <button class="navbar-toggler p-2" type="button" data-bs-toggle="dropdown" aria-expanded="false" (hidden.bs.dropdown)="submenus.reset()">
        <i class="bi bi-list fs-4 text-body"></i>
      </button>
      <ul class="dropdown-menu">
        <li>
          <a
            class="dropdown-item"
            href="javascript:void"
            type="button"
            aria-expanded="false"
            (click)="toggleTheme.emit(null)"
            >
            <span class="me-2">Toggle Theme</span>
            @if (isDarkTheme()) {
              <i class="bi bi-sun-fill fs-4"></i>
            }
            @if (!isDarkTheme()) {
              <i class="bi bi-moon-stars-fill fs-4"></i>
            }
          </a>
        </li>
        <li><hr class="dropdown-divider" /></li>
        @for (item of visibleMenuItems(); track item) {
          <li>
            @if ((item.children?.length ?? 0) > 0){
              <a class="dropdown-item" href="#" role="button" [attr.aria-expanded]="submenus.isOpen(item.text)" (click)="submenus.toggle(item.text, $event)">{{item.text}}</a>
              <ul class="dropdown-menu dropdown-submenu" [class.show-submenu]="submenus.isOpen(item.text)">
                @for (subItem of item.children; track $index) {
                  @if ((subItem.children?.length ?? 0) > 0) {
                    <li>
                      <a class="dropdown-header dropdown-item" href="#" role="button" [attr.aria-expanded]="submenus.isOpen(item.text + '::' + subItem.text)" (click)="submenus.toggle(item.text + '::' + subItem.text, $event)">{{subItem.text}}</a>
                      <ul class="dropdown-menu dropdown-submenu" [class.show-submenu]="submenus.isOpen(item.text + '::' + subItem.text)">
                        @for (leaf of subItem.children; track $index) {
                          <li>
                            <a class="dropdown-item" href="#" [routerLink]="leaf.route">{{leaf.text}}</a>
                          </li>
                        }
                      </ul>
                    </li>
                  } @else {
                    <li>
                      <a class="dropdown-item" href="#" [routerLink]="subItem.route">{{subItem.text}}</a>
                    </li>
                  }
                }
              </ul>
            } @else {
              <a class="dropdown-item" href="#" [routerLink]="item.route">{{item.text}}</a>
            }
          </li>
        }
      </ul>
    </div>
  }

  <a
    class="d-none d-md-block"
    href="javascript:void"
    type="button"
    aria-expanded="false"
    (click)="toggleTheme.emit(null)"
    >
    @if (isDarkTheme()) {
      <i class="bi bi-sun-fill fs-4 text-body"></i>
    }
    @if (!isDarkTheme()) {
      <i class="bi bi-moon-stars-fill fs-4 text-body"></i>
    }
  </a>
</nav>
